import { useState, useEffect } from 'react';

/**
 * useKeyboardOpen:
 * Detects whether the virtual keyboard is open on mobile devices
 * by monitoring window.visualViewport height changes against window.innerHeight.
 */
export function useKeyboardOpen(thresholdRatio: number = 0.75): boolean {
  const [isOpen, setIsOpen] = useState(false);

  useEffect(() => {
    if (typeof window === 'undefined' || !window.visualViewport) return;

    const handleResize = () => {
      const vv = window.visualViewport;
      if (!vv) return;
      setIsOpen(vv.height < window.innerHeight * thresholdRatio);
    };

    window.visualViewport.addEventListener('resize', handleResize);
    window.visualViewport.addEventListener('scroll', handleResize);

    return () => {
      window.visualViewport?.removeEventListener('resize', handleResize);
      window.visualViewport?.removeEventListener('scroll', handleResize);
    };
  }, [thresholdRatio]);

  return isOpen;
}

export default useKeyboardOpen;
